import ROUTER from '@/shared/config/routes'
import { maskId } from '@/shared/lib/format'

/**
 * BE đặt LinkUrl theo tên tiếng Anh (VBDT/Services/*); route FE là tiếng Việt.
 * Đường dẫn không có trong bảng này thì giữ nguyên nếu là đường dẫn nội bộ.
 */
const LINK_URL_TO_ROUTE: Record<string, string> = {
  '/dossier': ROUTER.QUAN_LY_HO_SO,
  '/my-dossier': ROUTER.MY_DOSSIERS,
  '/document': ROUTER.VAN_BANG,
  '/sign-queue': ROUTER.HANG_CHO_KY,
  '/system/user': ROUTER.QUAN_LY_NGUOI_DUNG,
}

/** Trả route FE để điều hướng; null nếu không phải đường dẫn nội bộ (không tự mở link ngoài). */
export const resolveNotificationLink = (linkUrl?: string | null): string | null => {
  if (!linkUrl?.startsWith('/') || linkUrl.startsWith('//')) return null
  const [path, rest = ''] = linkUrl.split(/(?=[?#])/, 2)
  const mapped = LINK_URL_TO_ROUTE[path]
  return mapped ? `${mapped}${rest}` : linkUrl
}

/**
 * Che PII trong nội dung thông báo do BE ghép sẵn: mã tài liệu sau cụm "Tài liệu"
 * và dãy số dài (CCCD/điện thoại, từ 9 chữ số). Mã bộ hồ sơ không phải PII nên giữ nguyên.
 */
export const maskNotificationContent = (content?: string | null): string => {
  if (!content) return ''
  return content
    .replace(
      /(Tài liệu\s+)([^\s,.;]+)/gi,
      (_m, prefix: string, num: string) => `${prefix}${maskId(num)}`
    )
    .replace(/\b\d{9,}\b/g, (digits) => maskId(digits))
}
